import { apiClient } from './client'
import type { CursorPage } from './accounts'
import type { ExternalAttestationView } from '../types/attestation'

/**
 * `GET /api/v1/program-filings/{programFilingId}/external-attestations` (already published,
 * `ExternalAttestationController.list`, ADR-0029) — a thin, additive frontend wrapper this
 * case-enrichment story adds (no new backend route). Backs the Case-workspace Evidence tab's
 * "linkage to attestations" enrichment: `ExternalAttestation.reportRef` resolves to an
 * `EvidenceItem.id` in the same Case, so this read lets that tab show which attestation(s) a given
 * evidence item backs, never a fabricated join.
 */
export async function listExternalAttestations(
  programFilingId: string,
  signal?: AbortSignal,
): Promise<CursorPage<ExternalAttestationView>> {
  const { data } = await apiClient.get<CursorPage<ExternalAttestationView>>(
    `/program-filings/${programFilingId}/external-attestations`,
    { signal },
  )
  return data
}
